import type { KeyValueSchema } from "./shared/key-value-overrides"

// Non-component members of the model edit dialog, kept here so the .tsx
// exports components only (react-refresh) and stays inside the file-size
// limit the repo holds its frontend to.

/**
 * The stored model document, as the raw-entity endpoint returns it.
 *
 * Indexed on purpose: the Form tab surfaces the fields admins touch most
 * often and the Raw tab writes the rest, so the dialog must be able to spread
 * a document containing keys it has never heard of without dropping them.
 */
export type StoredModel = {
  id?: string
  display_name?: string
  description?: string
  model_type?: string
  service_name?: string
  deployment?: string
  service_type?: string
  enabled?: boolean
  input_token_limit?: number
  output_token_limit?: number
  dimensions?: number
  feature_flags?: Record<string, unknown>
  disclaimers?: string[]
  access?: Record<string, unknown>
  [key: string]: unknown
}

/**
 * Known feature flags the backend recognises, used as schema hints for the
 * feature_flags KeyValueOverrides.
 */
export const FEATURE_FLAGS_SCHEMA: KeyValueSchema = {
  supports_tools: { type: "boolean", label: "supports_tools" },
  supports_vision: { type: "boolean", label: "supports_vision" },
  supports_streaming: { type: "boolean", label: "supports_streaming" },
  supports_reasoning: { type: "boolean", label: "supports_reasoning" },
}
